import React from "react";
import {getDisplayName, hoistNonReactStatics} from "@core-ui/utility";
import {useAppState} from "./AppStateContext";
import {SelectedAppState, Selector} from "./types";

export const withAppState = <Props extends SelectedAppState>(
  selector?: Selector
) => (Component: React.ComponentType<Props>) => {
  type WrappedComponentProps = Props & {forwardedRef?: React.Ref<any>};

  const WithAppState = ({
    forwardedRef,
    ...props
  }: WrappedComponentProps): JSX.Element => {
    const context = useAppState();
    let state: SelectedAppState;
    if (selector) {
      state = selector(context);
    } else {
      state = context;
    }
    return <Component ref={forwardedRef} {...state} {...(props as Props)} />;
  };

  WithAppState.displayName = `WithAppState(${getDisplayName(Component)})`;

  const WithHoistedStaticsAppState = hoistNonReactStatics(
    WithAppState,
    Component
  );

  const WithForwardedRefAppState = React.forwardRef<
    WrappedComponentProps["forwardedRef"],
    WrappedComponentProps
  >((props, ref) => {
    return <WithHoistedStaticsAppState {...props} forwardedRef={ref} />;
  });

  return hoistNonReactStatics(
    WithForwardedRefAppState,
    WithHoistedStaticsAppState
  );
};
